import * as tslib_1 from "tslib";
import { H3Button } from 'h3-mobile-vue';
import { Component, Prop, Vue } from "vue-property-decorator";
import common from '../../../../common/mobile';
import H3Scroll from "../../renderer/components/layout/h3-mescroll.vue";
let SearchPanel = class SearchPanel extends Vue {
    constructor() {
        super(...arguments);
        this.data = [];
        this.text = "";
        this.value = "";
        this.id = +new Date();
        this.fetching = false;
        this.fetched = false;
        this.page = 1;
        this.pageSize = 20;
        this.total = 0;
        this.searchMode = false;
        this.showFilter = false;
        /**
         * 单据状态筛选
         */
        this.formStatus = [];
        this.searchWays = [
            {
                name: '单据状态',
                type: 'status',
                icon: 'h-icon-all-down-o',
                activeIcon: 'h-icon-all-up-o'
            },
            {
                name: '筛选',
                type: 'filter',
                icon: 'h-icon-all-filter-o'
            }
        ];
        this.currentWay = '';
        this.urrentStatusName = [];
        this.currentStatusName = [];
        this.showState = false;
        /**
        * 根据表单状态筛选列表
        */
        this.queryFormState = '';
    }
    get noMore() {
        return this.$t("cloudpivot.form.renderer.noMore");
    }
    mounted() {
        this.el = document.querySelector('.tab-heard');
        if (this.el) {
            this.el.addEventListener('click', this.hideFilter);
        }
        ;
    }
    hideFilter() {
        this.showFilter = false;
    }
    beforeDestroy() {
        if (this.el) {
            this.el.removeEventListener('click', this.hideFilter);
        }
    }
    back() {
        this.$emit("back");
    }
    filter() {
        this.showFilter = !this.showFilter;
        this.$emit("filter", this.showFilter);
    }
    quitSearch() {
        if (this.backup) {
            this.data = this.backup.data;
            this.total = this.backup.total;
            this.page = this.backup.page;
        }
        this.searchMode = false;
        this.text = this.value = "";
    }
    entrySearch() {
        this.showFilter = false;
        this.backup = {
            data: this.data,
            total: this.total,
            page: this.page
        };
        this.searchMode = true;
        this.data = [];
        this.total = 0;
    }
    onSearch() {
        if (!this.fetch) {
            return;
        }
        clearTimeout(this.searchTimeoutRef);
        if (!this.text) {
            this.value = '';
            return;
        }
        this.searchTimeoutRef = setTimeout(() => {
            this.search();
        }, this.delay);
    }
    search() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.showFilter = false;
            this.page = 1;
            this.data = [];
            yield this.doFetch();
        });
    }
    reFetch() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.showFilter = false;
            this.page = 1;
            this.data = [];
            yield this.doFetch();
        });
    }
    loadMore(page, done) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.page = page.num;
            const seg = yield this.doFetch();
            if (done) {
                done(this.pageSize, seg.total);
            }
        });
    }
    doFetch() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.fetching = true;
            this.value = this.text;
            this.fetched = false;
            try {
                const seg = yield this.fetch(this.page, this.pageSize, this.value, this.queryFormState);
                this.total = seg.total;
                this.data = this.page === 1 ? seg.data : this.data.concat(seg.data);
                return seg;
            }
            finally {
                this.fetching = false;
                this.fetched = true;
            }
        });
    }
    beforeMount() {
        this.formStatus = [
            {
                name: `${this.$t('cloudpivot.list.mobile.Processing')}`,
                checked: false,
                status: 'PROCESSING'
            },
            {
                name: `${this.$t('cloudpivot.list.mobile.Completed')}`,
                checked: false,
                status: 'COMPLETED'
            },
            {
                name: `${this.$t('cloudpivot.list.mobile.Cancled')}`,
                checked: false,
                status: 'CANCELED'
            },
            {
                name: `${this.$t('cloudpivot.list.mobile.Draft')}`,
                checked: false,
                status: 'DRAFT'
            }
        ];
    }
    switchWay(item) {
        if (item.type === 'filter' && !this.enableFilter) {
            this.currentWay = '';
            this.$h3.toast.show({
                text: `${this.$t('cloudpivot.list.mobile.NoFilterTip')}`,
                iconType: 'close'
            });
            return;
        }
        if (item.type === 'filter') {
            this.showFilter = !this.showFilter;
            this.showState = false;
        }
        else {
            this.showState = !this.showState;
            this.showFilter = false;
        }
        if (this.showFilter || this.showState) {
            this.$emit("filter", true);
        }
        if (!this.showFilter && !this.showState) {
            this.$emit("filter", false);
        }
    }
    /**
     * 勾选单据状态状态选项
     */
    formSatusChange(index) {
        this.formStatus[index].checked = !this.formStatus[index].checked;
        this.logStatusNames();
    }
    logStatusNames() {
        this.currentStatusName = this.formStatus.map((item) => item.checked && item.name).filter(Boolean);
    }
    submitStatus() {
        this.currentWay = '';
        const formStatus = {
            propertyCode: 'sequenceStatus',
            propertyType: 0,
            propertyValue: ''
        };
        const targetArr = this.formStatus.filter((res) => res.checked);
        formStatus.propertyValue = targetArr.map((res) => res.status).join(';');
        this.showState = false;
        this.queryFormState = formStatus;
        this.search();
        this.$emit("filter", false);
    }
};
tslib_1.__decorate([
    Prop()
], SearchPanel.prototype, "fitlerWrapClass", void 0);
tslib_1.__decorate([
    Prop({
        default: 500
    })
], SearchPanel.prototype, "delay", void 0);
tslib_1.__decorate([
    Prop({
        type: Function
    })
], SearchPanel.prototype, "fetch", void 0);
tslib_1.__decorate([
    Prop({
        default: false
    })
], SearchPanel.prototype, "enableFilter", void 0);
SearchPanel = tslib_1.__decorate([
    Component({
        name: "search-panel",
        components: {
            H3Button,
            H3Scroll,
            CheckBox: common.components.Checkbox,
        },
        directives: {
            TransferDom: common.directives.transferDom
        }
    })
], SearchPanel);
export default SearchPanel;
